var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'invoice-page--mobile': !_vm.isDesktopLayout },style:(!_vm.isDesktopLayout ? _vm.mobilePageStyle : null)},[(_vm.isDesktopLayout)?_c('invoice-desktop-bridge'):_c('invoice-mobile',{ref:"invoiceMobile"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }